import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from './login/login.module';
import { AppBootstrapModule } from './app-bootstrap/app-bootstrap.module';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { AuthService } from './auth/auth.service';
import { HttpModule, Http } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './shared/_guards/auth.guard';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';
import { RegistrationModule } from './registration/registration.module';
import { UserManagementModule } from './user-management/user-management.module';
import { TokenInterceptor } from './auth/token.interceptor';
import { AuthInterceptor } from './auth/auth.interceptor';
import { LoadingModule } from 'ngx-loading';
import { SharedModule } from './shared/shared.module';
import { ChangePasswordModule } from './change-password/change-password.module';
import { ValidationService } from './shared/_services/validation.service';
import { UtilService } from './shared/_services/util.service';
import { CustomerReportModule } from './customer-report/customer-report.module';
import { SalesInvoiceModule } from './sales-invoice/sales-invoice.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpModule,
    AppRoutingModule,
    BrowserModule,
    AppBootstrapModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    LoginModule,
    ForgotPasswordModule,   
    RegistrationModule,
    ChangePasswordModule,  
    UserManagementModule,   
    LoadingModule,   
    SelectDropDownModule,  
    CustomerReportModule,
    SalesInvoiceModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [AuthService, AuthGuard, ValidationService, UtilService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts